import React from "react"

import { getAssetPath } from "@commonUtils"

import ImageLoader from "@components/ImageLoader/ImageLoader"
import css from "../Auth.scss"
import PropTypes from "prop-types"
const SuccessScreen = ({ closePopup, title, message, onCloseAction }) => {
    return (
        <>
            {closePopup && (
                <div className={`flex ${css.crossIcon} ${css.cursorPointer}`}>
                    <img
                        src={getAssetPath("svgs/icons/cross_18px_primary.svg")}
                        alt={"clear input"}
                        onClick={onCloseAction}
                    />
                </div>
            )}
            <div className={`${css.widthSuccessScreen} flexColumn alignCenter justifyCenter`}>
                <div>
                    <ImageLoader src={getAssetPath("svgs/icons/tick-green.svg")} width="80px" height="80px" />
                </div>
                <div className="l2Regular marginTop-8">{title}</div>
                {message && <div className="bodyRegular marginTop-4">{message}</div>}
            </div>
        </>
    )
}
SuccessScreen.propTypes = {
    closePopup: PropTypes.bool,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    onCloseAction: PropTypes.func,
}

export default SuccessScreen
